import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Type } from '../Type/Type';
// These are the constrained props from the NDS Type Guidelines
var sizeToProps = {
  'x-large': {
    chronicle: true,
    gotham: false,
    size: 5,
    uppercase: false
  },
  large: {
    chronicle: true,
    gotham: false,
    size: 4,
    uppercase: false
  },
  medium: {
    chronicle: false,
    gotham: true,
    size: 3,
    uppercase: false
  },
  small: {
    chronicle: false,
    gotham: true,
    size: 2,
    uppercase: false
  },
  'x-small': {
    chronicle: false,
    gotham: true,
    size: 1,
    uppercase: true
  }
};
var sizeToComponent = {
  'x-large': 'h1',
  large: 'h2',
  medium: 'h3',
  small: 'h4',
  'x-small': 'h5'
};
/**
 * Title abstraction over Type. We spread the constrained Title
 * props last and explicitly set others to undefined to prevent them from
 * being overridden.
 *
 * For example, all titles should be bold, and neutral-dark.
 */

export var Title = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      component = _ref.component,
      otherProps = _objectWithoutProperties(_ref, ["children", "size", "component"]);

  return /*#__PURE__*/React.createElement(Type, _extends({}, otherProps, {
    color: undefined,
    bold: true,
    component: component || sizeToComponent[size]
  }, sizeToProps[size], {
    ref: ref
  }), children);
});
Title.displayName = 'Title';